export const formName = "PersonalInformationForm";
export const PERSONAL_INFORMATION_UPDATE_ID = "settings/personal-information";
export const regionFieldName = "region";
